import { observer } from 'mobx-react-lite';
import isFunction from 'lodash/isFunction';
const ExpandedRow = observer(function ExpandedRow(props) {
    const { isExpanded, children = null, columnGroups, record } = props;
    if (isFunction(children)) {
        const child = children(columnGroups, record, isExpanded);
        if (child) {
            return child;
        }
    }
    return children;
});
ExpandedRow.displayName = 'ExpandedRow';
export default ExpandedRow;
